import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";
import { useMjmlStore } from "@/stores/mjmlStore";
import {
  TopolCustomBlockData,
  TopolCustomBlockMixContentWithKey,
} from "@/schemas/contentBlock/contentBlockScheme";
import { TopolLoopBlock } from "@/schemas/template/blocks/loopBlockSchema";
import { useMergeTagsStore } from "@/stores/mergeTags";
import button from "./button";
import image from "./image";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number },
    customBlockData?: TopolCustomBlockData | TopolCustomBlockMixContentWithKey
  ): TopolLoopBlock {
    const mjmlStore = useMjmlStore();

    const columnAttributes: Record<string, any> = {
      "vertical-align":
        mjmlStore.getBaseAttrString("mj-column", "vertical-align") || "top",
      padding: mjmlStore.getBaseAttrString("mj-column", "padding") || "0",
      width: "100%",
    };

    const colBgColor = mjmlStore.getBaseAttrString(
      "mj-column",
      "background-color"
    );
    if (colBgColor) columnAttributes["background-color"] = colBgColor;

    const colGradient = mjmlStore.getBaseAttrString(
      "mj-column",
      "column-gradient"
    );
    if (colGradient) columnAttributes["column-gradient"] = colGradient;

    const colBorderRadius = mjmlStore.getBaseAttrString(
      "mj-column",
      "border-radius"
    );
    if (colBorderRadius) columnAttributes["border-radius"] = colBorderRadius;

    const colBorder = mjmlStore.getBaseAttrString("mj-column", "border");
    if (colBorder) columnAttributes["border"] = colBorder;

    const colBorderTop = mjmlStore.getBaseAttrString("mj-column", "border-top");
    if (colBorderTop) columnAttributes["border-top"] = colBorderTop;

    const colBorderRight = mjmlStore.getBaseAttrString(
      "mj-column",
      "border-right"
    );
    if (colBorderRight) columnAttributes["border-right"] = colBorderRight;

    const colBorderBottom = mjmlStore.getBaseAttrString(
      "mj-column",
      "border-bottom"
    );
    if (colBorderBottom) columnAttributes["border-bottom"] = colBorderBottom;

    const colBorderLeft = mjmlStore.getBaseAttrString(
      "mj-column",
      "border-left"
    );
    if (colBorderLeft) columnAttributes["border-left"] = colBorderLeft;

    return {
      uid: uuidv4(),
      tagName: "mj-loop",
      attributes: {
        containerWidth: calcWidth(
          state.mjml.children[0].attributes["containerWidth"],
          state.mjml.children[0].children[props.sectionIndex].children[
            props.columnIndex
          ].attributes["width"]
        ),
        padding: "0px",
        "in-group": true,
      },
      forMergeTag: null,
      layout: "row",
      maxPerRow: 3,
      children: [
        {
          tagName: "mj-column",
          uid: uuidv4(),
          attributes: columnAttributes as any,
          children: [],
        },
      ],
    };
  },
};
